import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SnackBarContext } from "../../context/SnackBarContext";
import AppConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";
import Loader from "../../components/Loader/Loader";
import { MdDelete } from "react-icons/md";
import SitesDetailDialog from "../../components/Sites/SitesDetailDialog/SitesDetailDialog";
import { CiEdit } from "react-icons/ci";
import { fetchSitesData } from "../../redux/slice/SitesSlice/SitesSlice";
import { DeleteSiteApi } from "../../Apis/Sites/SitesApis";
import { fetchCompanyPopulate } from "../../redux/slice/CompanySlice/CompanySlice";
import CustomGrid from "../../components/common/CustomGrid/CustomGrid";
import JSZip from "jszip";
import { saveAs } from "file-saver";
// import { pdf } from "@react-pdf/renderer";
// import { WqcForm } from "../../components/Prints/WQC_form";
// import { ClForm } from "../../components/Prints/CL_form";
// import { FfcForm } from "../../components/Prints/FFC_form";
// import { EbrForm } from "../../components/Prints/EBR_form";
// import { PtForm } from "../../components/Prints/PT_form";
// import { IcForm } from "../../components/Prints/IC_form";
// import { VcForm } from "../../components/Prints/VC_form";
// import { WscForm } from "../../components/Prints/WSC_form";

import Papa from "papaparse";
// import ExcelJS from "exceljs";
import { FaDownload } from "react-icons/fa6";
function Sites() {
  const [alldata, setalldata] = useState([]);
  const [rows, setrows] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [showCompanyDetails, setShowCompanyDetail] = useState(false);
  const { setsnackBarData } = useContext(SnackBarContext);

  const { SitesData, status } = useSelector((state) => state?.Sites);
  const { CompanyPopulate, statusPopulate } = useSelector(
    (state) => state?.Companies
  );

  useEffect(() => {
    dispatch(fetchSitesData());
    dispatch(fetchCompanyPopulate());
  }, [dispatch]);

  useEffect(() => {
    if (SitesData) {
      setalldata(SitesData);
    } else {
      setalldata([]);
    }
  }, [SitesData]);

  const deleteCompany = async () => {
    setLoading(true);
    setShowConfirmation(false);

    const response = await DeleteSiteApi(selectedRow?.id);

    response?.snackBarData?.message && setsnackBarData(response?.snackBarData);
    if (response?.success) {
      dispatch(fetchSitesData());
      setSelectedRow(null);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    let arr = [];
    if (alldata) {
      alldata?.forEach((item, idx) => {
        arr.push({
          id: idx + 1,
          ...item,
        });
      });
    }
    setrows(arr);
  }, [alldata]);

  useEffect(() => {
    if (rows) {
      setFilteredData(rows);
    } else {
      setFilteredData([]);
    }
  }, [rows]);
  // const getFormComponent = (formName) => {
  //   switch (formName) {
  //     case "Cleanliness_Form":
  //       return ClForm;
  //     case "Fin_FanClosure_Form":
  //       return FfcForm;
  //     case "WQCF":
  //       return WqcForm;
  //     case "Bndl_Rls":
  //       return EbrForm;
  //     case "Hydro_Ts":
  //       return PtForm;
  //     case "Hydro_Ss":
  //       return PtForm;
  //     case "Internal_Closure_Form":
  //       return IcForm;
  //     case "Vessel_Closure_Form":
  //       return VcForm;
  //     case "WSCF":
  //       return WscForm;
  //     default:
  //       console.warn(`No component found for form: ${formName}`);
  //       return null;
  //   }
  // };

  // const generatePdfBlob = async (
  //   FormComponent,
  //   formData,
  //   text,
  //   reviewersData
  // ) => {
  //   try {
  //     console.log(reviewersData, "sdksjkj");

  //     const result = reviewersData?.reduce((acc, review) => {
  //       if (review.status === "Approved") {
  //         // Check if status is "Approved"
  //         const roleName = review?.role?.roleName
  //           .toLowerCase()
  //           .replace(/\s+/g, "");

  //         acc[
  //           roleName == "executive/jobsupervisor"
  //             ? "executivejobsupervisor"
  //             : roleName
  //         ] = {
  //           username: review?.reviewerId?.username,
  //           statusUpdatedAt: review?.statusUpdatedAt,
  //           signature: review?.reviewerId?.signature, // Assuming "signature" is equivalent to comments
  //         };
  //       }
  //       return acc;
  //     }, {});
  //     return await pdf(
  //       <FormComponent data={formData} rolesData={result} text={text} />
  //     ).toBlob();
  //   } catch (error) {
  //     console.error("Error generating PDF blob:", error);
  //     return null;
  //   }
  // };

  // const addFormToZip = async (zip, form, formData, reviewersData) => {
  //   const formName = form.formId?.name;
  //   const fileName = `${form?.formId?.title}.pdf`;

  //   let text;
  //   if (formName === "Hydro_Ts") {
  //     text = "TS";
  //   } else if (formName === "Hydro_Ss") {
  //     text = "SS";
  //   }

  //   if (formData) {
  //     const pdfBlob = await generatePdfBlob(
  //       getFormComponent(formName),
  //       formData,
  //       text ? text : undefined,
  //       reviewersData
  //     );
  //     if (pdfBlob) {
  //       zip.file(fileName, pdfBlob);
  //     }
  //   } else {
  //     console.error(`Form ${formName} is missing submission data`);
  //   }
  // };


  // function buildSheetFromForm(sheet, formObj, data) {
  //   const formLayouts = {
  //     "VCDC-ND": {
  //       title: "Vessel Calculation Data Collection",
  //       sections: {
  //         General: {
  //           "Eq/Cric": "equipmentNumber",
  //           Unit: "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           Service: "description",
  //           Facility: "facility",
  //         },
  //         Code: {
  //           "Div 1 or Div 2": "division",
  //           "Code Year": "yearBuilt",
  //           "Vertical or Horizontal": "orient",
  //         },
  //         Shell: {
  //           Material: "shellMaterial",
  //           "Fine Grain": "fineGrain",
  //           PWHT: "pwht",
  //           Efficiency: "jointEfficiency",
  //           "Length (in)": "lengthIn",
  //           "Nominal Thickness (in)": "orgThickness",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn",
  //         },
  //         "Upper Shell": {
  //           "Vessel ID (in)": "vesselIdIn",
  //           "Internal Pressure (PSI)": "internalPressurePsi",
  //           "Internal Temp (F)": "internalTempF",
  //           "External Pressure (PSI)": "externalPressurePsi",
  //           "External Temp (F)": "externalTempF",
  //           MDMT: "mdmtPerNameplateOrU1A",
  //           Hydro: "hydroPressureTempDate",
  //         },
  //         "Lower Shell": {
  //           "Vessel ID (in)": "vesselIdIn1",
  //           "Internal Pressure (PSI)": "internalPressurePsi1",
  //           "Internal Temp (F)": "internalTempF1",
  //           "External Pressure (PSI)": "externalPressurePsi1",
  //           "External Temp (F)": "externalTempF1",
  //           MDMT: "mdmtPerNameplateOrU1A1",
  //           Hydro: "hydroPressureTempDate1",
  //         },
  //         MISC: {
  //           "PSV Set Pressure (PSI)": "setPressure",
  //           "Max Liquid Fill Height (in)": "eqHeight",
  //           "Liquid Specific Gravity": "liquidSpecificGravity",
  //         },
  //         "Top Head": {
  //           "Hemi/Torr/Flat": "hemi21TorrFlat",
  //           Material: "material1",
  //           "Fine Grain": "fineGrain1",
  //           Efficiency: "efficiencyOrRtMark1",
  //           "Nominal Thickness (in)": "nominalThicknessIn1",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn1",
  //         },
  //         "Bottom Head": {
  //           "Hemi/Torr/Flat": "hemi21TorrFlat1",
  //           Material: "material2",
  //           "Fine Grain": "fineGrain2",
  //           Efficiency: "efficiencyOrRtMark2",
  //           "Nominal Thickness (in)": "nominalThicknessIn2",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn2",
  //         },
  //       },
  //     },
  //     "NDC": {
  //       title: "Nozzle Data Collection",
  //       sections: {
  //         General: {
  //           "Eq/Cric": "equipmentNumber",
  //           Unit: "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           Service: "description",
  //           Facility: "facility",
  //         },
  //         Nozzle: {
  //           "Nozzle #": "compId",
  //           Location: "location",
  //           "Flange Rating": "flangeRating",
  //           "Nozzle Size": "diameter",
  //           "Nozzle Thickness": "orgThickness",
  //           "Base Plate Thickness": "baseMetalThick",
  //           "Repad Thickness (a)": "repadThick",
  //           "Repad Width (b)": "repadWidth",
  //           "Fillet Weld Size (c)": "repadFilletWeldSize",
  //           "Fillet Weld Size (d)": "nozFilletWeldSize",
  //           "Distance from nozzle center line  to nearest seam":
  //             "distanceFromNozzleCenterLineToNearestSeam",
  //         },
  //       },
  //     },
  //     "VCDCC": {
  //       title: "Vessel Calculation Data Collection Components",
  //       sections: {
  //         General: {
  //           "Eq/Cric": "equipmentNumber",
  //           Unit: "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           Service: "description",
  //           Facility: "facility",
  //         },
  //         Component: {
  //           "Component Description": "componentDescription",
  //           "Component Type": "componentType",
  //           Material: "material",
  //           "Fine Grain": "fineGrain",
  //           "PWHT (Y or N)": "pwht",
  //           "Efficiency (or RT mark)": "efficiencyOrRtMark",
  //           "Length (in)": "lengthIn",
  //           "Centerline distance from seam (Specify which)":
  //             "centerlineDistance",
  //           "Nominal Thickness (in)": "nominalThicknessIn",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn",
  //         },
  //       },
  //     },
  //     "SSDC": {
  //       title: "Saddle Support Data Collection",
  //       sections: {
  //         General: {
  //           "Eq/Cric": "equipmentNumber",
  //           Unit: "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           Service: "description",
  //           Facility: "facility",
  //         },
  //         Design: {
  //           "Number of saddles": "numberOfSaddles",
  //           Material: "material",
  //           "Allowable Tensile Stress": "allowableTensileStress",
  //           "Allowable Yield Stress": "allowableYieldStress",
  //           "Right Saddle Distance from": "rightSaddleDistanceFrom",
  //           " Datum (L)": "datumL",
  //           "Saddle Width (b)": "saddleWidthB",
  //           "Saddle Height (H)": "saddleHeightH",
  //           "Saddle Contact Angle (theta)": "saddleContactAngleTheta",
  //         },
  //         "Wear Plate": {
  //           "Has Wear Plate": "hasWearPlate",
  //           "Wear Plate Thickness (tp)": "wearPlateThicknessTp",
  //           "Wear Plate Width (Wp)": "wearPlateWidthWp",
  //           "Wear Plate Contact Angle": "wearPlateContactAngle",
  //           "Hort to Wear Plate (h)": "hortToWearPlateH",
  //         },
  //         Web: {
  //           "Web (Center or Edge)": "webCenterOrEdge",
  //           "Web Thickness (ts)": "webThicknessTs",
  //           "Base Plate Length ( E )": "basePlateLengthE",
  //           "Base Plate Width (F)": "basePlateLengthE1",
  //           "Base Plate Thickness (tb) ": "basePlateThicknessTb",
  //           "Base Plate Extends (X)": "basePlateExtendsX",
  //         },
  //         Ribs: {
  //           "Number or Ribs*": "ribThicknessIn",
  //           "Rib Spacing (in)": "ribSpacingIn",
  //           "Rib Thickness (in)": "ribThicknessIn",
  //         },
  //         MISC: {
  //           "Height of Saddle base above ground (in)":
  //             "heightOfSaddleBaseAboveGroundIn",
  //         },
  //       },
  //     },
  //   };

  //   const formType = formObj?.formId?.title;
  //   const layout = formLayouts[formType];
  //   if (!layout) return;

  //   // Sheet setup
  //   sheet.columns = [{ width: 40 }, { width: 25 }];

  //   sheet.mergeCells("A1:B1");
  //   const titleCell = sheet.getCell("A1");
  //   titleCell.value = layout.title;
  //   titleCell.font = { size: 16, bold: true };
  //   titleCell.alignment = { horizontal: "center" };

  //   let rowIndex = 3;
  //   let colorIndex = 0;
  //   const sectionColors = [
  //     "FFFDE9D9",
  //     "FFE2EFDA",
  //     "FFD9E1F2",
  //     "FFFCE4D6",
  //     "FFF2F2F2",
  //   ];

  //   // 🔥 pick latestSubmission.data if exists
  //   const formData = formObj?.latestSubmission?.data || data || {};

  //   // Render sections
  //   for (const [sectionName, keyMap] of Object.entries(layout.sections)) {
  //     const bgColor = sectionColors[colorIndex % sectionColors.length];
  //     colorIndex++;

  //     if (formType === "NDC" && sectionName === "Nozzle") {
  //       // multiple nozzles
  //       const nozzleArray = formData.nozzle1 || [];
  //       nozzleArray.forEach((nozzle, nozzleIndex) => {
  //         sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
  //         const subHeader = sheet.getCell(`A${rowIndex}`);
  //         subHeader.value = `Nozzle ${nozzleIndex + 1}`;
  //         subHeader.font = { bold: true, size: 12 };
  //         subHeader.alignment = { horizontal: "center" };
  //         subHeader.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: bgColor },
  //         };
  //         rowIndex++;

  //         Object.entries(keyMap).forEach(([label, key]) => {
  //           const labelCell = sheet.getCell(`A${rowIndex}`);
  //           const valueCell = sheet.getCell(`B${rowIndex}`);
  //           labelCell.value = label;
  //           labelCell.font = { bold: true };
  //           labelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //           valueCell.value = nozzle[key] ?? "";
  //           valueCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  //           valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //           rowIndex++;
  //         });

  //         rowIndex += 2;
  //       });
  //     } else if (formType === "VCDCC" && sectionName === "Component") {
  //       const compArray = formData.dataGrid || [];
  //       compArray.forEach((comp, compIndex) => {
  //         sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
  //         const subHeader = sheet.getCell(`A${rowIndex}`);
  //         subHeader.value = `Component ${compIndex + 1}`;
  //         subHeader.font = { bold: true, size: 12 };
  //         subHeader.alignment = { horizontal: "center" };
  //         subHeader.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: bgColor },
  //         };
  //         rowIndex++;

  //         Object.entries(keyMap).forEach(([label, key]) => {
  //           const labelCell = sheet.getCell(`A${rowIndex}`);
  //           const valueCell = sheet.getCell(`B${rowIndex}`);
  //           labelCell.value = label;
  //           labelCell.font = { bold: true };
  //           labelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //           valueCell.value = comp[key] ?? "";
  //           valueCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  //           valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //           rowIndex++;
  //         });

  //         rowIndex += 2;
  //       });
  //     } else {
  //       // Normal section
  //       sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
  //       const sectionCell = sheet.getCell(`A${rowIndex}`);
  //       sectionCell.value = sectionName;
  //       sectionCell.font = { bold: true, size: 13 };
  //       sectionCell.alignment = { horizontal: "center" };
  //       sectionCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //       rowIndex++;

  //       Object.entries(keyMap).forEach(([label, key]) => {
  //         const labelCell = sheet.getCell(`A${rowIndex}`);
  //         const valueCell = sheet.getCell(`B${rowIndex}`);
  //         labelCell.value = label;
  //         labelCell.font = { bold: true };
  //         labelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //         valueCell.value = formData[key] ?? "";
  //         valueCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  //         valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
  //         rowIndex++;
  //       });

  //       rowIndex += 2;
  //     }
  //   }
  // }

  // const handleDownloadZip = async (insData) => {
  //   const zip = new JSZip();
  //   const packages = insData?.packages || [];

  //   for (const pkg of packages) {
  //     // Folder name: number_title
  //     const pkgFolderName = `${pkg.number || "NO_NUM"}(${pkg.title?.replace(/\s+/g, "_")})`;
  //     const pkgFolder = zip.folder(pkgFolderName);

  //     for (const stage of pkg.stagesdata || []) {
  //       const formType = stage?.formId?.title || `Stage_${stage.stageLevel}`;
  //       const submissionData = stage?.latestSubmission?.data || {};
  //       const reviewersData = stage?.reviewers || [];

  //       // file base: StageLevel_FormTitle
  //       const fileBase = `Stage-${stage.stageLevel}_${formType}`.replace(/\s+/g, "_");

  //       if (["VCDC-ND", "NDC", "VCDCC", "SSDC"].includes(formType)) {
  //         // Excel Export
  //         const workbook = new ExcelJS.Workbook();
  //         const sheet = workbook.addWorksheet(formType.substring(0, 30));
  //         await buildSheetFromForm(sheet, stage, submissionData);
  //         const buffer = await workbook.xlsx.writeBuffer();
  //         pkgFolder.file(`${fileBase}.xlsx`, buffer);
  //       } else {
  //         // PDF Export
  //         await addFormToZip(pkgFolder, stage, submissionData, reviewersData, fileBase);
  //       }
  //     }
  //   }

  //   try {
  //     const zipFile = await zip.generateAsync({ type: "blob" });
  //     saveAs(zipFile, `${insData?.name}_packages.zip`);
  //   } catch (error) {
  //     console.error("Error generating ZIP file:", error);
  //   }
  // };


  const handleDownloadZip = async (insData) => {
    const zip = new JSZip();
    const packages = insData?.packages || [];

    const formLayouts = {
      "VCDC-ND": {
        title: "Vessel Calculation Data Collection",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Code: {
            "Div 1 or Div 2": "division",
            "Code Year": "yearBuilt",
            "Vertical or Horizontal": "orient",
          },
          Shell: {
            Material: "shellMaterial",
            "Fine Grain": "fineGrain",
            PWHT: "pwht",
            Efficiency: "jointEfficiency",
            "Length (in)": "lengthIn",
            "Nominal Thickness (in)": "orgThickness",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn",
            // },
            // "Shell Course": {
            "Vessel ID (in)": "vesselIdIn",
            "Internal Pressure (PSI)": "internalPressurePsi",
            "Internal Temp (F)": "internalTempF",
            "External Pressure (PSI)": "externalPressurePsi",
            "External Temp (F)": "externalTempF",
            MDMT: "mdmtPerNameplateOrU1A",
            Hydro: "hydroPressureTempDate",
          },
          // "Lower Shell": {
          //   "Vessel ID (in)": "vesselIdIn1",
          //   "Internal Pressure (PSI)": "internalPressurePsi1",
          //   "Internal Temp (F)": "internalTempF1",
          //   "External Pressure (PSI)": "externalPressurePsi1",
          //   "External Temp (F)": "externalTempF1",
          //   MDMT: "mdmtPerNameplateOrU1A1",
          //   Hydro: "hydroPressureTempDate1",
          // },
          MISC: {
            "PSV Set Pressure (PSI)": "setPressure",
            "Max Liquid Fill Height (in)": "eqHeight",
            "Liquid Specific Gravity": "liquidSpecificGravity",
          },
          "Top Head": {
            "Hemi/Torr/Flat": "hemi21TorrFlat",
            Material: "material1",
            "Fine Grain": "fineGrain1",
            Efficiency: "efficiencyOrRtMark1",
            "Nominal Thickness (in)": "nominalThicknessIn1",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn1",
          },
          "Bottom Head": {
            "Hemi/Torr/Flat": "hemi21TorrFlat1",
            Material: "material2",
            "Fine Grain": "fineGrain2",
            Efficiency: "efficiencyOrRtMark2",
            "Nominal Thickness (in)": "nominalThicknessIn2",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn2",
          },
          Comment: {
            Comment: "textArea",
          }
        },
      },
      NDC: {
        title: "Nozzle Data Collection",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            "Unit": "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            "Facility": "facility",
          },
          Nozzle: {
            "Nozzle #": "compId",
            Location: "location",
            "Flange Rating": "flangeRating",
            "Nozzle Size": "diameter",
            "Nozzle Thickness": "orgThickness",
            "Base Plate Thickness": "baseMetalThick",
            "Repad Thickness (a)": "repadThick",
            "Repad Width (b)": "repadWidth",
            "Fillet Weld Size (c)": "repadFilletWeldSize",
            "Fillet Weld Size (d)": "nozFilletWeldSize",
            "Distance from nozzle center line  to nearest seam":
              "distanceFromNozzleCenterLineToNearestSeam",
            "Reference Material": "refMaterial"

          },
          Comment: {
            Comment: "comment",
          }
        },
      },
      VCDCC: {
        title: "Vessel Calculation Data Collection Components",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Component: {
            "Component Description": "componentDescription",
            "Component Type": "componentType",
            Material: "material",
            "Fine Grain": "fineGrain",
            "PWHT (Y or N)": "pwht",
            "Efficiency (or RT mark)": "efficiencyOrRtMark",
            "Length (in)": "lengthIn",
            "Centerline distance from seam (Specify which)": "centerlineDistance",
            "Nominal Thickness (in)": "nominalThicknessIn",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn",
          },
          Comment: {
            Comment: "comment",
          }
        },
      },
      SSDC: {
        title: "Saddle Support Data Collection",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Design: {
            "Number of saddles": "numberOfSaddles",
            Material: "material",
            "Allowable Tensile Stress": "allowableTensileStress",
            "Allowable Yield Stress": "allowableYieldStress",
            "Right Saddle Distance from": "rightSaddleDistanceFrom",
            " Datum (L)": "datumL",
            "Saddle Width (b)": "saddleWidthB",
            "Saddle Height (H)": "saddleHeightH",
            "Saddle Contact Angle (theta)": "saddleContactAngleTheta",
          },
          "Wear Plate": {
            "Has Wear Plate": "hasWearPlate",
            "Wear Plate Thickness (tp)": "wearPlateThicknessTp",
            "Wear Plate Width (Wp)": "wearPlateWidthWp",
            "Wear Plate Contact Angle": "wearPlateContactAngle",
            "Hort to Wear Plate (h)": "hortToWearPlateH",
          },
          Web: {
            "Web (Center or Edge)": "webCenterOrEdge",
            "Web Thickness (ts)": "webThicknessTs",
            "Base Plate Length ( E )": "basePlateLengthE",
            "Base Plate Width (F)": "basePlateLengthE1",
            "Base Plate Thickness (tb) ": "basePlateThicknessTb",
            "Base Plate Extends (X)": "basePlateExtendsX",
          },
          Ribs: {
            "Number or Ribs*": "ribThicknessIn",
            "Rib Spacing (in)": "ribSpacingIn",
            "Rib Thickness (in)": "ribThicknessIn",
          },
          MISC: {
            "Height of Saddle base above ground (in)":
              "heightOfSaddleBaseAboveGroundIn",
          },
          Comment: {
            Comment: "comment",
          }
        },
      },
    };

    // Collect all forms grouped by type
    const allForms = {};
    for (const pkg of packages) {
      for (const stage of pkg.stagesdata || []) {
        const type = stage?.formId?.title;
        if (!formLayouts[type]) continue;
        const data = stage?.latestSubmission?.data || {};
        if (!allForms[type]) allForms[type] = [];
        const rows = flattenFormData(type, data, pkg, formLayouts[type]);
        allForms[type].push(...rows);
      }
    }

    // Create one CSV file per form type and add to ZIP
    for (const [type, rows] of Object.entries(allForms)) {
      if (!rows.length) continue;

      // Collect headers dynamically
      const allHeaders = new Set();
      rows.forEach((r) => Object.keys(r).forEach((k) => allHeaders.add(k)));
      const headers = [
        "S.No",
        "Package",
        ...Array.from(allHeaders).filter(
          (h) => !["S.No", "Package",].includes(h)
        ),
      ];

      // Add S.No column values
      const csvData = rows.map((r, i) => ({
        ...r,
        "S.No": i + 1,
      }));

      // Convert JSON → CSV using PapaParse
      const csv = Papa.unparse({
        fields: headers,
        data: csvData.map((r) => headers.map((h) => r[h] || "")),
      });

      // Add CSV to zip
      zip.file(`${type}.csv`, csv);
    }

    // Generate and download ZIP
    try {
      const zipFile = await zip.generateAsync({ type: "blob" });
      saveAs(zipFile, `${insData?.name}_forms_csv_data.zip`);
    } catch (error) {
      console.error("Error generating ZIP:", error);
    }

    // Helper functions
    function flattenFormData(type, data, pkg, layout) {
      const baseInfo = {
        Package: pkg.number || "",
      };
      const rows = [];

      if (type === "NDC") {
        (data.nozzle1 || []).forEach((noz) => {
          rows.push({
            ...baseInfo,
            ...mapLayoutFields({ General: layout.sections.General }, data),
            // Component-specific info (from "comp")
            ...mapLayoutFields({ Nozzle: layout.sections.Nozzle }, noz),
          });
        });
      } else if (type === "VCDCC") {
        (data.dataGrid || []).forEach((comp) => {
          rows.push({
            ...baseInfo,
            // General info (from parent "data")
            ...mapLayoutFields({ General: layout.sections.General }, data),
            // Component-specific info (from "comp")
            ...mapLayoutFields({ Component: layout.sections.Component }, comp),
          });
        });
      } else if (type === "VCDC-ND") {
        const sectionNames = ["Top Head", "Bottom Head"];
        sectionNames.forEach((sec) => {
          rows.push({
            ...baseInfo, // Package & Inspection
            ...mapLayoutFields({ General: layout.sections.General }, data), // Add general info
            Section: sec, // Section label
            ...mapLayoutFields({ [sec]: layout.sections[sec] }, data), // Section-specific fields
            ...mapLayoutFields({ MISC: layout.sections.MISC }, data), // Optional: MISC fields
          });
        });
        (data.dataGrid || []).forEach((noz) => {
          rows.push({
            ...baseInfo,
            ...mapLayoutFields({ General: layout.sections.General }, data),
            Section: "Shell",
            ...mapLayoutFields({ Shell: layout.sections.Shell }, noz),
          });
        });
      } else {
        rows.push({ ...baseInfo, ...mapLayoutFields(layout.sections, data) });
      }

      return rows;
    }

    function mapLayoutFields(sections, formData, subData = null) {
      const row = {};
      for (const [_, keyMap] of Object.entries(sections)) {
        console.log(_);
        for (const [label, key] of Object.entries(keyMap)) {
          const value = subData ? subData[key] ?? "" : formData[key] ?? "";
          // Force text for Excel for all string-like values
          row[label] = typeof value === "string" && value.includes("/")
            ? `="${value}"`
            : value;
        }
      }
      return row;
    }

  };




  const handleFilterChange = (event) => {
    const value = event.target.value;
    const regex = new RegExp(value, "i"); // 'i' flag makes the search case-insensitive
    let filteredData = rows;
    const filtered = filteredData.filter(
      (item) =>
        regex.test(item?.name) ||
        regex.test(item?.email) ||
        regex.test(item?.phoneNumber) ||
        regex.test(item?.companyId) ||
        regex.test(item?.jobsiteNo)
    );

    setFilteredData(filtered);
  };
  const columns = [
    {
      Header: "ID",
      accessor: "id", // Accessor is the "key" in the data
      width: "20px",
    },
    {
      Header: "Job Site #",
      accessor: "jobsiteNo",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Company Name",
      accessor: "companyName",
    },
    // {
    //   Header: "Phone",
    //   accessor: "phoneNumber",
    // },
    {
      Header: "Phone",
      accessor: "phoneNumber",
      Cell: ({ value }) => {
        const digits = value.replace(/\D/g, "");

        return `+1 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(
          6
        )}`;
      },
    },

    {
      Header: "Equipments",
      accessor: "equipments",
      disableSortBy: true,
      Cell: (cell) => (
        <div className="flex items-center">
          <button
            className="btn btn-outline-secondary mx-2 "
            onClick={() => {
              setSelectedRow(cell?.row?.original);
              navigate("/sites/sites-view", {
                state: {
                  data: cell?.row?.original?._id,
                  type: "equipment",
                },
              });
            }}
          >
            View
          </button>
        </div>
      ),
    },
    {
      Header: "Equipments Working",
      accessor: "equip-working",
      disableSortBy: true,
      Cell: (cell) => (
        <div className="flex items-center">
          <button
            className="btn btn-outline-secondary mx-2 "
            onClick={() => {
              setSelectedRow(cell?.row?.original);
              navigate("/sites/sites-view", {
                state: {
                  data: cell?.row?.original?._id,
                  type: "equipmentWorking",
                },
              });
            }}
          >
            View
          </button>
        </div>
      ),
    },
    {
      Header: "Components Working",
      accessor: "comp-working",
      disableSortBy: true,
      Cell: (cell) => (
        <div className="flex items-center">
          <button
            className="btn btn-outline-secondary mx-2 "
            onClick={() => {
              setSelectedRow(cell?.row?.original);
              navigate("/sites/sites-view", {
                state: {
                  data: cell?.row?.original?._id,
                  type: "componentWorking",
                },
              });
            }}
          >
            View
          </button>
        </div>
      ),
    },
    // {
    //   Header: "Download Zip",
    //   accessor: "download",
    //   disableSortBy: true,
    //   Cell: (cell) => (
    //     <div className="flex items-center">
    //       <button className="btn btn-outline-secondary mx-2" onClick={() => handleDownloadZip(cell?.row?.original)}
    //       >
    //         Download
    //       </button> </div>
    //   ),
    // },

    {
      Header: "Actions",
      accessor: "actions",

      disableSortBy: true, // Disable sorting for actions
      Cell: (cell) => (
        <div className="flex items-center">
          <CiEdit
            title="Edit Site"
            className="icon view-icon"
            onClick={() => {
              setSelectedRow(cell?.row?.original);
              navigate("/sites/form", { state: cell?.row?.original });
              // console.log("selected",cell?.row?.original);
            }}
          />
          <FaDownload
            size={18}
            title="Download zip "
            className="icon view-icon"
            onClick={() => handleDownloadZip(cell.row.original)}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="mb-2">
        <div className="row g-2 align-items-center me-lg-5">
          {/* Search Input */}
          <div className="col-12 col-md-6 col-lg-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search By Name, Site #, Email or Phone"
              onChange={handleFilterChange}
            />
          </div>

          {/* Company Select */}
          <div className="col-12 col-md-6 col-lg-3">
            <select
              className="form-select"
              onChange={handleFilterChange}
            >
              <option value="">Select Company</option>
              {CompanyPopulate?.map((item, idx) => (
                <option key={idx} value={item?.id}>
                  {item?.companyName}
                </option>
              ))}
            </select>
          </div>

          {/* Total Records */}
          <div className="col-12 col-md-6 col-lg-3 d-flex justify-content-center justify-content-md-start">
            <p className="mb-0">
              Total Records:
              <span className="fw-bold dark-text"> {filteredData.length}</span>
            </p>
          </div>

          {/* New Button */}
          <div className="col-12 col-md-6 col-lg-3 d-flex justify-content-end justify-content-md-end">
            <button
              className="btn btn-primary"
              onClick={() => navigate("/sites/form")}
            >
              New
            </button>
          </div>
        </div>
      </div>


      {status === "loading" || statusPopulate === "loading" || loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <CustomGrid columns={columns} data={filteredData} />
      )}
      {showConfirmation && (
        <AppConfirmationDialog
          open={showConfirmation}
          onDeny={() => {
            setSelectedRow(null);
            setShowConfirmation(false);
          }}
          onConfirm={() => {
            deleteCompany();
          }}
          iconContainerColor="#fbeaea"
          icon={<MdDelete color="red" />}
          dialogTitle="Delete Site"
          title={`Are you sure, you want to delete site ${selectedRow?.name}?`}
          successText="Yes"
          successBtnColor="danger"
          cancelText="No"
        />
      )}
      {/* {status === "loading" || statusPopulate === "loading" || loading ? (
        <Loader />
      ) : null} */}
      {showCompanyDetails && (
        <SitesDetailDialog
          open={showCompanyDetails}
          onClose={() => {
            setSelectedRow(null);
            setShowCompanyDetail(false);
          }}
          state={selectedRow}
        />
      )}
    </>
  );
}

export default Sites;
